import { z } from 'zod';
import { oneOf, str } from '../../navigation/searchParams';

/** The template list filters, and the editor, preview, history and duplicate dialogs. */
export const emailTemplatesSearch = z.object({
  q: str,
  category: str,
  active: oneOf(['active', 'inactive']),
  modal: oneOf(['create-template', 'edit-template', 'preview', 'history', 'duplicate']),
  id: str,
  mtab: str,
});
